import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FinalCTA = () => {
  return (
    <div className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-green-800 rounded-2xl shadow-2xl overflow-hidden"
        >
          <div className="px-8 py-12 sm:px-12 sm:py-16 text-center">
            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              Prêt à nous faire confiance ?
            </h2>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Link to="/dedicated-pricing-page">
                <Button
                  size="lg"
                  className="w-full sm:w-auto bg-white !text-green-900 hover:bg-gray-100 font-semibold px-8 py-3 rounded-lg shadow-md transition-all duration-300"
                >
                  <Icon name="Package" size={20} className="mr-2 !text-green-900" />
                  Commander ma barrique
                </Button>
              </Link>
              <Link to="/professional-services-landing-page">
                <Button
                  size="lg"
                  variant="outline"
                  className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-green-700 font-semibold px-8 py-3 rounded-lg transition-all duration-300"
                >
                  <Icon name="Briefcase" size={20} className="mr-2" />
                  Demander un devis pro
                </Button>
              </Link>
            </div>

            {/* Phone Number */}
            <div className="flex items-center justify-center gap-2 text-white">
              <Icon name="Phone" size={20} />
              <p className="text-lg">
                Ou appelez-nous : <span className="font-bold">06 51 98 86 21</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FinalCTA;